import { render } from "./InvestorTable.vue?vue&type=template&id=7503ead8&scoped=true"
import script from "./InvestorTable.vue?vue&type=script&lang=js"
export * from "./InvestorTable.vue?vue&type=script&lang=js"

import "./InvestorTable.vue?vue&type=style&index=0&id=7503ead8&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7503ead8"]])

export default __exports__